import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * WireInstruction API
 */
class WireInstructionApi extends ApiBase {
  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/wireinstructions/validateimport`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  async importFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/wireinstructions/importexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  /**
   * create Wire Instructions
   * @param {*} createWireInstructions
   */
  async createWireInstructions(createWireInstructions) {
    const request = {
      url: `${this.API_URL}/wireinstructions`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(createWireInstructions)
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Get wire instructions template excel
   */
  async getWireInstructionsExcelTemplate() {
    const request = {
      url: `${this.API_URL}/wireinstructions/import/template`,
      headers: this.getHeaders(),
      method: 'GET',
      responseType: 'blob'
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Get wire instructions as excel
   * @param entityId investor id
   */
  async getWireInstructionsAsExcel(entityId) {
    const request = {
      url: `${this.API_URL}/wireinstructions//excel?entityId=${encodeURI(
        entityId
      )}`,
      headers: this.getHeaders(),
      method: 'GET',
      responseType: 'blob'
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Create multiple
   * @param {*} wireInstructions
   * @returns
   */
  createMultipleWireInstructions = async wireInstructions => {
    const request = {
      url: `${this.API_URL}/wireinstructions`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(wireInstructions)
    };

    const response = await axios.request(request);

    return response.data && response.data.pageData;
  };
}
export default new WireInstructionApi();
